/* eslint-disable */
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";

const filterDialogStyle = (theme, clientColor) => ({
  ...modalStyle(theme),
  ...customSelectStyle(theme, clientColor),
  
  filterModalHeaderScope: {
    color: grayColor[0]
  },
  filterModalHeaderFilterName: {
    fontWeight: "bold"
  },
  filterModalActionContainer: {
    paddingRight: "5px !important"
  },
  filterModalAction: {
    color: grayColor[0],
    fontSize: "12px",
    cursor: "pointer",
    "&:hover": {
      color: grayColor[6]
    }
  },
  filterModalCounter: {
    textAlign: "right",
    color: grayColor[0],
    fontSize: "12px"
  },
  orDivider: {
    color: grayColor[0],
    fontSize: "16px",
    textAlign: "center",
    margin: "-4px 0 0"
  },
  firstArrow: {
    marginTop: "20px"
  },
  arrow: {
    textAlign: "center",
    fontSize: "22px",
    color: grayColor[5],
    opacity: "0.6",
    transition: "all 0.2s"
  },
  arrowSelected: {
    color: clientColor,
    transform: "scale(2)",
    opacity: "1"
},

  customUnderline: {
    "&:after": {
      borderBottomColor: `${clientColor} !important`
    }
  },
  unavailable: {
    fontStyle: "italic"
  },
  marginBottomSmall: {
    marginBottom: "8px"
  }
});

export default filterDialogStyle;